import { httpCreate } from './http';

const http = httpCreate('/srv/soho-sign');

export const sohoSign = {
	bankCardInfo() {
		return http.get('');
	},
	delete() {
		return http.delete('rescindSoho');
	},
	bind(data) {
		return http.post('', data);
	},
	modify(data) {
		return http.put('', data);
	},
};
